import { render, staticRenderFns } from "./StepHeader.vue?vue&type=template&id=079da484&scoped=true&"
import script from "./StepHeader.vue?vue&type=script&lang=js&"
export * from "./StepHeader.vue?vue&type=script&lang=js&"
import style0 from "./StepHeader.vue?vue&type=style&index=0&id=079da484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079da484",
  null
  
)

export default component.exports